module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAALCAYAAACksgdhAAAACXBIWXMAAAsSAAALEgHS3X78AAAAvUlEQVQokYWQsQ2DMBBFX1D6ILnFIh10ZARGYASyAdkgm0TZICOQDUjnMpFbkJIJnOYsWQbBl6443/37/xvnHGs1ZkU7ZsUwZkXq3xK2cQUqoJ90eQLWSZMuWyCXtgKOmyRR8bgrax6rpEjlBXR+lkSLzaTLdEGlVdZ8fbOPLt+A86RLApWLsmYIj++cc8iv9MAB+MgsB57Kmjq27u29pfxyDvyAZp5WSOK3lsAeTZhjZi/IlYrNXlnTLREA/satVpBJ6hAUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos-icons/bullet-dav-ok-red.png
// module id = 693
// module chunks = 1